import { render, staticRenderFns } from "./ContratoLpsModal.vue?vue&type=template&id=dfc61f80&scoped=true"
import script from "./ContratoLpsModal.vue?vue&type=script&lang=js"
export * from "./ContratoLpsModal.vue?vue&type=script&lang=js"
import style0 from "./ContratoLpsModal.vue?vue&type=style&index=0&id=dfc61f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc61f80",
  null
  
)

export default component.exports